import { useAuthContext } from '@contexts/authContext'
import { MapView } from '@contexts/mapDataContext'
import styled from '@emotion/styled/macro'
import { size } from '@styles/theme'

import { thumbnailLargeNoFallback, thumbnailMediumNoFallback } from '@utils/thumbnails'
import ImageUploadButton from '@elements/ImageUploadButton'
import { ImageUploadLabel } from './SharedFormComponents'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${size(1.5)};
  flex-shrink: 0;

  padding-left: ${size(1)};
  padding-right: ${size(1)};
`

const NonMainImages = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${size(1.5)};
  flex-shrink: 0;
  flex-grow: 0.3;
`

const MainImageUploadLabel = styled(ImageUploadLabel)`
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  aspect-ratio: 1/1;
`

const buttonSlotProps = {
  containerButton: {
    style: {
      borderRadius: '20px',
      flexGrow: 1,
      flexShrink: 0,
      aspectRatio: '1/1'
    }
  }
}

const NearbyImageForm = ({ setUser }) => {
  const { state: authState, handleInstantUpdate } = useAuthContext()

  const handleRemovalSuccess = (thumbnailSortOrder) => {
    const updatedUser = { ...authState?.user }
    if (updatedUser?.nearbyMedia?.thumbnails?.[thumbnailSortOrder]) {
      updatedUser.nearbyMedia.thumbnails[thumbnailSortOrder] = null
      handleInstantUpdate(updatedUser)
      MapView.updateUser(updatedUser?.nearbyUuid, updatedUser)
      if (typeof setUser === 'function') setUser(updatedUser) // <-- Local to own profile
    }
  }

  const handleImageUpdateSucess = (updatedUser) => {
    if (typeof setUser === 'function') setUser(updatedUser) // <-- Local to own profile
  }

  return (
    <Container>
      <MainImageUploadLabel>
        <ImageUploadButton
          existingUrl={thumbnailLargeNoFallback(authState?.user?.nearbyMedia?.thumbnails?.[0])}
          slots={buttonSlotProps}
          uniqueDialogType='nearby_main'
          onUpdateSuccess={handleImageUpdateSucess}
          onRemovalSuccess={() => handleRemovalSuccess(0)}
          formatRemovalParams={() => ({
            params: {
              sort_order: 0,
              roles: [
                'nearby_profile_small',
                'nearby_profile_medium',
                'nearby_profile_large',
              ]
            }
          })}
          formatRequestData={(originalFile, croppedFile) => {
            const formData = new FormData()
            formData.append('user_is_parent', true)
            formData.append('treat_as_set', true)
            formData.append('sort_order', 0)
        
            formData.append('files[]', originalFile)
            formData.append('roles[]', 'nearby_profile_large')
            
            formData.append('files[]', croppedFile)
            formData.append('roles[]', 'nearby_profile_medium')
            return formData
          }}
        />
      </MainImageUploadLabel>
      <NonMainImages>
        <ImageUploadButton
          existingUrl={thumbnailMediumNoFallback(authState?.user?.nearbyMedia?.thumbnails?.[1])}
          slots={buttonSlotProps}
          btnSize={size(10)}
          uniqueDialogType='nearby_1'
          onUpdateSuccess={handleImageUpdateSucess}
          onRemovalSuccess={() => handleRemovalSuccess(1)}
          formatRemovalParams={() => ({
            params: {
              sort_order: 1,
              roles: [
                'nearby_profile_small',
                'nearby_profile_medium',
                'nearby_profile_large'
              ]
            }
          })}
          formatRequestData={(originalFile, croppedFile) => {
            const formData = new FormData()
            formData.append('user_is_parent', true)
            formData.append('treat_as_set', true)
            formData.append('sort_order', 1)
        
            formData.append('files[]', originalFile)
            formData.append('roles[]', 'nearby_profile_large')
            
            formData.append('files[]', croppedFile)
            formData.append('roles[]', 'nearby_profile_medium')
            return formData
          }}
        />
        <ImageUploadButton
          existingUrl={thumbnailMediumNoFallback(authState?.user?.nearbyMedia?.thumbnails?.[2])}
          slots={buttonSlotProps}
          btnSize={size(10)}
          uniqueDialogType='nearby_2'
          onUpdateSuccess={handleImageUpdateSucess}
          onRemovalSuccess={() => handleRemovalSuccess(2)}
          formatRemovalParams={() => ({
            params: {
              sort_order: 2,
              roles: [
              'nearby_profile_small',
              'nearby_profile_medium',
              'nearby_profile_large'
              ]
            }
          })}
          formatRequestData={(originalFile, croppedFile) => {
            const formData = new FormData()
            formData.append('user_is_parent', true)
            formData.append('treat_as_set', true)
            formData.append('sort_order', 2)
        
            formData.append('files[]', originalFile)
            formData.append('roles[]', 'nearby_profile_large')
            
            formData.append('files[]', croppedFile)
            formData.append('roles[]', 'nearby_profile_medium')
            return formData
          }}
        />
        <ImageUploadButton
          existingUrl={thumbnailMediumNoFallback(authState?.user?.nearbyMedia?.thumbnails?.[3])}
          slots={buttonSlotProps}
          btnSize={size(10)}
          uniqueDialogType='nearby_3'
          onUpdateSuccess={handleImageUpdateSucess}
          onRemovalSuccess={() => handleRemovalSuccess(3)}
          formatRemovalParams={() => ({
            params: {
              sort_order: 3,
              roles: [
                'nearby_profile_small',
                'nearby_profile_medium',
                'nearby_profile_large'
              ]
            }
          })}
          formatRequestData={(originalFile, croppedFile) => {
            const formData = new FormData()
            formData.append('user_is_parent', true)
            formData.append('treat_as_set', true)
            formData.append('sort_order', 3)
        
            formData.append('files[]', originalFile)
            formData.append('roles[]', 'nearby_profile_large')
            
            formData.append('files[]', croppedFile)
            formData.append('roles[]', 'nearby_profile_medium')
            return formData
          }}
        />
      </NonMainImages>
    </Container>
  )
}

export { NearbyImageForm }
